import Routes from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/common/Locales/Locales';
import ScrollTop from 'components/common/ScrollTop/ScrollTop';
import Snackbar from 'components/ui/Snackbar/Snackbar';
import Notistack from 'components/features/third-party/Notistack';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import { AuthProvider } from 'contexts/JWTContext';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import CustomCookieBanner from 'components/common/CustomCookieBanner/CustomCookieBanner';
import { MEASUREMENT_ID } from 'config';

const initializeGA = measurementId => {
    if (!measurementId) {
        console.error('GA Measurement ID (REACT_APP_MEASUREMENT_ID) is not defined.');
        return;
    }
    if (!ReactGA.isInitialized) {
        ReactGA.initialize(measurementId);
    }
};

const App = () => {
    const location = useLocation();
    const measurementId = MEASUREMENT_ID;

    const [consentGiven, setConsentGiven] = useState(Cookies.get('CookieConsent') === 'true');
    const [showBanner, setShowBanner] = useState(!Cookies.get('CookieConsent'));

    useEffect(() => {
        if (consentGiven) {
            initializeGA(measurementId);
            if (ReactGA.isInitialized) {
                ReactGA.send({
                    hitType: 'pageview',
                    page: location.pathname + location.search,
                });
            }
        }
    }, [location, consentGiven, measurementId]);

    const handleAcceptConsent = () => {
        setConsentGiven(true);
        Cookies.set('CookieConsent', 'true', { expires: 150 });
        setShowBanner(false);
    };

    const handleDeclineConsent = () => {
        setConsentGiven(false);
        Cookies.set('CookieConsent', 'false', { expires: 150 });
        Cookies.remove('_ga');
        Cookies.remove(`_ga_${measurementId?.replace('G-', '')}`);
        setShowBanner(false);
    };

    return (
        <ThemeCustomization>
            <Locales>
                <ScrollTop>
                    <AuthProvider>
                        <Notistack>
                            <ToastContainer />
                            <Routes />
                            <Snackbar />
                        </Notistack>
                    </AuthProvider>
                </ScrollTop>
            </Locales>

            {showBanner && <CustomCookieBanner onAccept={handleAcceptConsent} onDecline={handleDeclineConsent} />}
        </ThemeCustomization>
    );
};

export default App;
